import {gql, useMutation} from '@apollo/client'

const useSetPaymentStripeMethodsToUser = (onCompleted = () => {}, onError = () => {}) => {
    return useMutation(
        gql`
            mutation (
                $paymentMethods: [PaymentMethodsFromStripeToUser!]!
                $userId: String!
                $stripeId: String!
            ) {
                setPaymentStripeMethodsToUser (
                    paymentMethods: $paymentMethods
                    userId: $userId
                    stripeId: $stripeId
                )
            }
        `,
        {
            onCompleted, onError
        }
    )
}

export default useSetPaymentStripeMethodsToUser
